export const ProductStatuses = {
  ARCHIVED: "archived",
  LIVE: "live"
};
